const state = {
  colleaguesList: {
    data: [],
    pagination: [],
  },
  colleaguesStatus: [],
  activeInternalCallStatus: null,
  activeInternalCalllColleagueInfo: null,
  showColleaguesCallInProgressCard: false,
  showColleaguesCallRingingCard: false,
};

export default state;
